import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { TeilaufgabeAdmin, TeilaufgabenSolutionTable } from "@reflact/ipkv-types";
import { firstValueFrom } from 'rxjs';

type RelatedTestAnswers = Record<string, {
  type: 'standard';
  answers: string[];
} | {
  type: 'table';
  answers: string[][];
}>;

@Injectable({
  providedIn: 'root'
})
export class TeilaufgabenService {
  public teilaufgaben: TeilaufgabeAdmin[] = [];
  public selectedTeilaufgabe: TeilaufgabeAdmin | undefined = undefined;
  private http = inject(HttpClient);
  private baseRoute = "/api/admin/teilaufgabe";

  public async create(createOpts: { aufgabenstellung: string, teilaufgabenIndex: number, aufgabenId: string, type: 'standard' | 'table' }) {
    const createResult = await firstValueFrom(this.http.post<TeilaufgabeAdmin>(this.baseRoute + "/create", createOpts));
    this.teilaufgaben.push(createResult);
    return createResult._id;
  }

  public async getKiResult(teilaufgabeId: string, userAnswers: string[] | string[][], relatedAnswers?: RelatedTestAnswers) {
    const payload = {
      teilaufgabeId,
      userAnswers,
      ...(relatedAnswers != null && { relatedAnswers })
    };
    const result = await firstValueFrom(this.http.post<{ kiComment: string, kiScore: string, kiReasoning: string, promptMessages: { role: string; content: string }[] }>(this.baseRoute + "/getaianswer", payload));
    return result
  }

  public async getKiResultTable(teilaufgabeId: string, userAnswers: string[] | string[][], relatedAnswers?: RelatedTestAnswers) {
    const payload = {
      teilaufgabeId,
      userAnswers,
      ...(relatedAnswers != null && { relatedAnswers })
    };
    const result = await firstValueFrom(this.http.post<{ kiTable: TeilaufgabenSolutionTable["kiTable"], kiReasoning: string, promptMessages: { role: string; content: string }[] }>(this.baseRoute + "/getaianswer", payload));
    return result
  }


  public async pasteTeilaufgabe(teilaufgabeId: string, targetAufgabeId: string) {
    const pasteResult = await firstValueFrom(this.http.post<TeilaufgabeAdmin>(this.baseRoute + "/pasteteilaufgabe", {
      teilaufgabeId,
      targetAufgabeId
    }));
    this.teilaufgaben.push(pasteResult);
    return pasteResult._id
  }

  public async update() {

    console.log("his.selectedTeilaufgabe", this.selectedTeilaufgabe)
    const selectedTeilaufgabeWithRelated = this.selectedTeilaufgabe as (TeilaufgabeAdmin & { relatedTeilaufgaben?: string[]; }) | undefined;
    const payload = {
      ...this.selectedTeilaufgabe,
      relatedTeilaufgaben: selectedTeilaufgabeWithRelated?.relatedTeilaufgaben ?? []
    };
    const updateResult = await firstValueFrom(this.http.post<TeilaufgabeAdmin>(this.baseRoute + "/update", payload));
    const index = this.teilaufgaben.findIndex((ta) => ta._id === updateResult._id);
    if (index >= 0 && this.teilaufgaben[index]) this.teilaufgaben[index] = updateResult;
    if (this.selectedTeilaufgabe && updateResult._id === this.selectedTeilaufgabe._id) this.selectedTeilaufgabe = updateResult;
  }

  public async updateTestAnswerSets() {
    if (!this.selectedTeilaufgabe) return;
    const updateResult = await firstValueFrom(this.http.post<TeilaufgabeAdmin>(this.baseRoute + "/update", {
      _id: this.selectedTeilaufgabe._id,
      testAnswerSets: this.selectedTeilaufgabe.testAnswerSets ?? []
    }));
    if (this.selectedTeilaufgabe && updateResult._id === this.selectedTeilaufgabe._id) {
      this.selectedTeilaufgabe.testAnswerSets = updateResult.testAnswerSets;
    }
  }

  public async reorder(reorderOpts: { aufgabenId: string, dragIndex: number, dropIndex: number }) {
    const data = await firstValueFrom(this.http.post<TeilaufgabeAdmin[]>(this.baseRoute + "/reorder", reorderOpts));
    this.sort(data);
  }

  public async delete(_id: string, aufgabenId: string) {
    const data = await firstValueFrom(this.http.post<TeilaufgabeAdmin[]>(this.baseRoute + "/delete", { _id, aufgabenId }));
    this.sort(data);
  }

  public set(id: string) {
    const teilaufgabe = this.teilaufgaben.find(ta => ta._id === id);
    if (teilaufgabe) this.selectedTeilaufgabe = teilaufgabe;
  }

  public reset() {
    this.selectedTeilaufgabe = undefined;
  }

  public sort(data: TeilaufgabeAdmin[]) {
    this.teilaufgaben = data.sort((a, b) => {
      if (a.teilaufgabenIndex < b.teilaufgabenIndex) return -1;
      if (a.teilaufgabenIndex > b.teilaufgabenIndex) return 1;
      return 0;
    });
  }

  public getTeilAufgabeById(teilaufgabenId: string) {
    return this.teilaufgaben.find(ta => ta._id == teilaufgabenId)
  }
}
